import React from "react";

import { nuevaGestionHref } from "../../crmpostventa-shared/crmLinks";
import NuevaGestionButton from "./NuevaGestionButton";
import "../../crmpostventa-rollo/rollo.css";
import "../ipc.css";

/**
 * "Registrar gestión" in the Ficha del cliente (design Prompt 7, point 3): a secondary button, styled like the Ficha's
 * "Editar datos", with a menu of real links to the alta of Gestiones IPC ("Gestión IPC" and "Proactiva"). Each link
 * carries the Ficha's alta (clienteId = IdAlta) and its terminal number, so the alta opens in step 2 with the
 * comercio and the terminal loaded. Without a valid alta (clienteId = IdAlta) there is nothing to link to and the button is not shown.
 */
export default function RegistrarGestionMenu({ clienteId, numeroTerminal, darkMode = false, onNavigate }) {
  const hrefFor = (request) => nuevaGestionHref({ categoria: request.categoria, clienteId, numeroTerminal });
  if (!hrefFor({ categoria: "IPC" })) return null;

  return (
    <div className={`crm-rollo crm-ipc crm-ipc-registrar${darkMode ? " is-dark" : ""}`}>
      <NuevaGestionButton
        label="Registrar gestión"
        buttonClassName="crm-postventa-ficha-edit-btn"
        hrefFor={hrefFor}
        onSelect={(request) => onNavigate?.(hrefFor(request))}
      />
    </div>
  );
}
